<!-- <template>
  <div class="animated fadeIn">
    <b-row>
      <sub-division-financial-chart :lgSize="12" :lgOffset="0" :locParam="1" :idCity="0"></sub-division-financial-chart>
    </b-row>
  </div>
</template>

<script>
import { Chart } from "highcharts-vue";
import SubDivisionFinancialChart from '../../components/SubDivisionFinancialChart.vue';

export default {
  name: "dashboard",
  components: {
    highcharts: Chart,
    SubDivisionFinancialChart
  }
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
</style> -->

<template>
  <b-col sm="12" :lg="12" :offset-lg="0">
    <div class="animated fadeIn">
      <DateModal
        modalID="sub_division"
        :fetchData="fetchData"
        :dateFrom="dateFrom"
        :dateTo="dateTo"
        @date-picker-modal-emit="onDatePickerModalEmit"
      ></DateModal>
      <b-card class="backClass" header="Received">
        <div
          slot="header"
          style="display:flex; justify-content: space-between;"
        >
          <HeaderTitle
            title="Delivered Equipment"
            :dateFrom="
              from(dateFrom)
                ? $formatUSDate(from(dateFrom))
                : $formatUSDate(dateFrom)
            "
            :dateTo="
              to(dateTo) ? $formatUSDate(to(dateTo)) : $formatUSDate(dateTo)
            "
          ></HeaderTitle>
          <HeaderControl
            :showFullscreenIcon="true"
            :showDateIcon="true"
            :showDownloadPdfIcon="true"
            @emit-fullscreen="toggleFullScreen"
            @emit-date="modalDateEvent"
            @emit-pdf-download="downloadPDF"
          ></HeaderControl>
        </div>
        <div class="chart-wrapper">
          <LoadingCard v-if="loadingData"></LoadingCard>
          <highcharts
            ref="backRef"
            v-else
            :options="chartOptions"
            class="chart"
            :constructor-type="'chart'"
          ></highcharts>
        </div>
      </b-card>
    </div>
  </b-col>
</template>

<script>
import { Chart } from "highcharts-vue";
import router from "../../../router";
import Datepicker from "vuejs-datepicker";
import { Switch as cSwitch } from "@coreui/vue";
import DateModal from "../../../components/shared/DateModal.vue";
import HeaderTitle from "../../../components/shared/HeaderTitle.vue";
import HeaderControl from "../../../components/shared/HeaderControl.vue";
import LoadingCard from "../../../components/shared/LoadingCard.vue";
import { SubDivisionFinancialChartChart } from "../../../utils/ChartProps";
import { from, isUserLoggedIn, to } from "../../../utils/Utils";

export default {
  name: "SubDivisionFinancial",
  components: {
    router,
    highcharts: Chart,
    Datepicker,
    cSwitch,
    DateModal,
    HeaderTitle,
    HeaderControl,
    LoadingCard
  },
  data: function() {
    return {
      from: from,
      to: to,
      fullscreen: false,
      loadingData: false,
      showAll: false,
      modalDate: false,
      valueQuantity: false,
      dateName: "",
      dateFrom: "",
      dateTo: "",
      locationName: "",
      productGroup: "",
      locationsIds: "",
      chartOptions: {},
      locParam: 1,
      idCity: 0
    };
  },
  watch: {
    dateFrom() {
      this.chartOptions = SubDivisionFinancialChartChart(
        router,
        this.from(this.dateFrom),
        this.to(this.dateTo)
      );
    },
    dateTo() {
      this.chartOptions = SubDivisionFinancialChartChart(
        router,
        this.from(this.dateFrom),
        this.to(this.dateTo)
      );
    },
    valueQuantity() {
      this.fetchData();
      if (this.fullScreen) {
        this.$refs.backRef.chart.options.chart.height = "50%";
      } else {
        this.$refs.backRef.chart.options.chart.height = 400;
      }
    }
  },
  methods: {
    modalDateEvent() {
      this.exitFullscreen();
      this.$bvModal.show("sub_division");
    },
    exitFullscreen() {
      if (!this.fullscreen) {
        return;
      } else {
        this.toggleFullScreen();
      }
    },
    toggleFullScreen() {
      this.$fullscreen.toggle(this.$el.querySelector(".backClass"), {
        wrap: false,
        callback: this.fullscreenChange
      });
    },
    onDatePickerModalEmit(changedDateFrom, changedDateTo) {
      this.dateFrom = changedDateFrom;
      this.dateTo = changedDateTo;
    },
    fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen;
      if (this.fullscreen) {
        this.$refs.backRef.chart.options.chart.height = "50%";
      } else {
        this.$refs.backRef.chart.options.chart.height = 400;
      }
      this.$refs.backRef.chart.reflow();
    },
    fetchData() {
      this.loadingData = true;
      let params = {};
      let finType = "Fin";

      params = {
        type: finType,
        date_from: this.from(this.dateFrom),
        date_to: this.to(this.dateTo)
      };
      this.$http
        .get("api/charts/subDivisionFinance.php", {
          params
        })
        .then(
          res => {
            if (finType == "Fin") {
              this.chartOptions.title.text = "Total : $" + res.data.totals;
            } else {
              this.chartOptions.title.text = "Total units: " + res.data.totals;
            }

            if (!this.showAll) {
              let tmp = res.data.upData;
              tmp.sort((a, b) =>
                parseFloat(a.locationTotal) > parseFloat(b.locationTotal)
                  ? -1
                  : 1
              );

              let newArr = tmp.slice(0, 10);
              if (this.locParam == 0) {
                // if (smp.length != 0) {
                //   this.chartOptions.series[0].data = smp[0].data;
                // }
              } else {
                this.chartOptions.series[0].data = newArr;
              }
            } else {
              let tmp = res.data.upData;
              tmp.sort((a, b) =>
                parseFloat(a.locationTotal) > parseFloat(b.locationTotal)
                  ? -1
                  : 1
              );
              this.chartOptions.series[0].data = tmp;
            }

            this.loadingData = false;
            setTimeout(() => {
              this.changeHeight();
            });
          },
          err => {
            this.loadingData = false;
            console.log(err);
          }
        );
    },
    changeHeight() {
      if (this.fullscreen) {
        this.$refs.backRef.chart.options.chart.height = "50%";
      } else {
        this.$refs.backRef.chart.options.chart.height = 400;
      }
      this.$refs.backRef.chart.reflow();
    },
    downloadPDF() {
      this.$refs.backRef.chart.options.title.text =
        "Regional Analytics Finance";

      this.$refs.backRef.chart.options.title.style.color = "black";

      this.$refs.backRef.chart.options.title.style.display = "block";
      this.$refs.backRef.chart.options.drilldown.activeAxisLabelStyle.color =
        "black";

      this.$refs.backRef.chart.options.xAxis.forEach(obj => {
        obj.labels.style.color = "black";
      });

      this.$refs.backRef.chart.exportChart({
        type: "application/pdf",
        filename: "RegionalAnalyticsDelivered"
      });

      this.$refs.backRef.chart.options.drilldown.activeAxisLabelStyle.color =
        "white";
    }
  },
  mounted() {
    isUserLoggedIn(router);
    if (this.locParam == 1) {
      this.locationsIds = localStorage.getItem("locations");
    } else {
      this.locationsIds = this.idCity;
    }
    this.valueQuantity = false;
    let fromDate = new Date();
    fromDate.setDate(fromDate.getDate() - 30);

    this.dateFrom = fromDate.toJSON().slice(0, 10);
    this.dateTo = new Date().toJSON().slice(0, 10);
    this.chartOptions = SubDivisionFinancialChartChart(
      router,
      this.from(this.dateFrom),
      this.to(this.dateTo)
    );

    this.fetchData();
  }
};
</script>

<style>
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
.vdp-datepicker__calendar {
  position: absolute !important;
  z-index: 100;
  background: #3a4149 !important;
  width: 300px;
  border: 1px solid #ccc;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: #515b65 !important;
  opacity: 1 !important;
}
.title-details {
  padding: 0.5em;
  padding-bottom: 0.2em !important;
  font-size: 1.1em;
  display: block;
}
.highcharts-exporting-group {
  display: none !important;
}
</style>
